import { initContract } from '@ts-rest/core';
import { z } from 'zod';
import { WeeklyScoreSchema, MonthlyScoreSchema, DateRangeQuerySchema, ErrorResponseSchema, } from './schemas';
const c = initContract();
export const scoresContract = c.router({
    weekly: {
        method: 'GET',
        path: '/scores/weekly',
        query: DateRangeQuerySchema.extend({
            employeeId: z.string().optional(),
        }),
        responses: {
            200: z.object({
                success: z.literal(true),
                data: z.array(WeeklyScoreSchema),
            }),
            401: ErrorResponseSchema,
        },
        summary: 'Get weekly scores',
    },
    monthly: {
        method: 'GET',
        path: '/scores/monthly',
        query: z.object({
            month: z
                .string()
                .regex(/^\d{4}-\d{2}$/, { error: 'Month must be YYYY-MM' })
                .optional(),
            employeeId: z.string().optional(),
        }),
        responses: {
            200: z.object({
                success: z.literal(true),
                data: z.array(MonthlyScoreSchema),
            }),
            401: ErrorResponseSchema,
        },
        summary: 'Get monthly scores',
    },
});
//# sourceMappingURL=scores.js.map